import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; Združenie vlastníkov "p.s." Kečkovce</p>
    </footer>
  );
}

export default Footer;
